// src/hooks/useAddPrescription.ts

import { useMutation } from "@tanstack/react-query";
import { Methods } from "../../Constants/ApiConstants";
import { EndPoints } from "../../Constants/endpoints";
import { GeneralResponse, IAddPrescription } from "../../interface/GeneralResponse";
import Api from "../generalApi/Api";

const useAddPrescription = () => {
  const mutation = useMutation({
    mutationFn: (data: IAddPrescription): Promise<GeneralResponse> => {
      return Api<IAddPrescription, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.CreatePrescription,
        body: data,
      });
    },
  });

  return mutation;
};

export default useAddPrescription;
